/* ============================================================
   VIRELLO — PDP interactions (loaded on product pages)
   ============================================================ */
(function () {
  'use strict';

  /* ── Gallery thumbnail switcher ── */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (o) { o.classList.remove('active'); });
        t.classList.add('active');
        main.classList.add('fading');
        setTimeout(function () {
          main.src = t.getAttribute('data-src');
          main.classList.remove('fading');
        }, 200);
      });
    });
  }

  /* ── Variant pill selectors (re-rendered on Shopify variant change) ── */
  function initVariantPills() {
    document.querySelectorAll('[data-variant-group]').forEach(function (group) {
      group.querySelectorAll('.pill').forEach(function (p) {
        p.addEventListener('click', function () {
          group.querySelectorAll('.pill').forEach(function (o) { o.classList.remove('active'); });
          p.classList.add('active');
          // dispatch a variant change event so Shopify section can update
          var optionName = group.getAttribute('data-option-name');
          var value = p.getAttribute('data-value');
          var ev = new CustomEvent('virello:variant-option-change', { detail: { name: optionName, value: value } });
          document.dispatchEvent(ev);

          // update the label
          var labelStrong = group.parentElement.querySelector('.variant-label strong');
          if (labelStrong) labelStrong.textContent = value;
        });
      });
    });
  }

  /* ── Quantity stepper ── */
  function initQty() {
    var input = document.querySelector('[data-qty-input]');
    var down  = document.querySelector('[data-qty-down]');
    var up    = document.querySelector('[data-qty-up]');
    if (!input) return;
    if (down) down.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (up) up.addEventListener('click', function () {
      input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1);
    });
  }

  /* ── Mini compatibility checker (inline in buy box) ── */
  function initCompatQuick() {
    var card = document.querySelector('[data-compat-quick]');
    if (!card) return;
    var os   = card.querySelector('[data-cq-os]');
    var port = card.querySelector('[data-cq-port]');
    var result = card.querySelector('[data-cq-result]');
    var text   = card.querySelector('[data-cq-text]');
    if (!os || !port || !result || !text) return;

    /* This product's own connection options (from custom.connection metafield) */
    var conn = (card.getAttribute('data-cq-connection') || '').toLowerCase();
    function hasHDMI() { return conn.indexOf('hdmi') !== -1; }
    function hasUSBC() { return conn.indexOf('usb-c') !== -1 || conn.indexOf('usb c') !== -1 || conn.indexOf('onecable') !== -1; }

    function decide() {
      if (port.value === 'hdmi-only') {
        if (conn && !hasHDMI()) return { warn: true, html: 'This model connects via USB-C only — for an HDMI laptop, choose an HDMI-capable model.' };
        return { warn: true, html: 'Works over HDMI — add the <strong>HDMI cable bundle</strong> at checkout.' };
      }
      if (port.value === 'unsure')    return { warn: true, html: '<strong>Check your laptop specs</strong> for "DisplayPort over USB-C".' };
      if (conn && !hasUSBC())         return { warn: true, html: 'This model connects over HDMI — see the connection options above.' };
      if (os.value === 'macos-m')     return { warn: false, html: 'Compatible. M-series MacBooks drive both screens through one USB-C port.' };
      if (os.value === 'macos-intel') return { warn: false, html: 'Compatible. Intel MacBooks need both USB-C ports for power + display.' };
      if (os.value === 'linux')       return { warn: false, html: 'Compatible. Recognised automatically on kernel 5.4+.' };
      if (os.value === 'chromeos')    return { warn: false, html: 'Compatible with modern Chromebooks supporting external displays.' };
      return { warn: false, html: 'Compatible. Plug &amp; play on Windows.' };
    }
    function update() {
      var d = decide();
      result.classList.toggle('warn', !!d.warn);
      var c = result.querySelector('.check');
      if (c) c.textContent = d.warn ? '!' : '✓';
      text.innerHTML = d.html;
    }
    [os, port].forEach(function (el) { el.addEventListener('change', update); });
    update();
  }

  function init() {
    initGallery();
    initVariantPills();
    initQty();
    initCompatQuick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();